import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { FuseWidgetModule } from '../../../../../core/components/widget/widget.module';
import { MatAutocompleteModule } from '@angular/material';

import { ActosComponent } from './actos.component';
import { ActosService } from '../../../../services/actos/actos.service';
import { SchoolYearService } from '../../../../services/schoool-year/school-year.service';
import { EmployeeService } from '../../../../services/employee/employee.service';
import { ShiftService } from '../../../../services/shifts/shift.service';

const routes = [
    {
        path: 'pages/management/actos',
        component: ActosComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_ACTOS',
                redirectTo: '/pages/errors/error-403'
            }
        }
    }
];

@NgModule({
    declarations: [
        ActosComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule,
        MatAutocompleteModule
    ],
    exports: [
        ActosComponent
    ],
    providers: [
        ActosService,
        SchoolYearService,
        EmployeeService,
        ShiftService
    ]
})
export class ActosModule { }



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/actos/actos.module.ts